import { useEffect, useRef } from 'react';
/**
 * Hook that detects clicks outside of the passed ref
 * @param handler Function to call when click outside is detected
 * @param enabled Whether the click outside detection is enabled
 */
export function useClickOutside(handler, enabled = true, shouldIgnoreEvent) {
    const ref = useRef(null);
    useEffect(() => {
        if (!enabled) {
            return;
        }
        const handleClickOutside = (event) => {
            if (shouldIgnoreEvent?.(event)) {
                return;
            }
            if (ref.current && event.target instanceof Node && !ref.current.contains(event.target)) {
                handler();
            }
        };
        // Use mousedown for faster response (before click event)
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [enabled, handler, shouldIgnoreEvent]);
    return ref;
}
//# sourceMappingURL=useClickOutside.js.map